import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/life&workdesign/01/thumbnail.jpg'

const paperInfo = {
  paperName: 'commmune導入事例_ライフ＆ワークデザイン株式会社様',
  thumbnail: thumbnail,
  feature1: 'コミュニティによる新たなビジネス機会の創出例',
  feature2: 'コミュニティで挑戦していること',
  feature3: 'コミュニティユーザーからの期待',
  description:
    '会員制シェアオフィス「Business-Airport」「Plug and Play Shibuya powered by 東急不動産」事業の運営管理を行なっているライフ&ワークデザイン株式会社の導入事例です。この資料を読むことで、BtoBビジネスにおけるコミュニティ活用方法の理解がより深まります。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-06-26/hjlrw',
  type: 'pardot'
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
